import { type FC, type PropsWithChildren, useEffect } from 'react';
import useMeasure from 'react-use-measure';

import { setCssVar } from '@/common/lib/cssVar';
import { ResourceTitle } from '@/components/ResourceTitle/ResourceTitle';

const FactoryTitle: FC<PropsWithChildren> = ({ children }) => {
  const [titleRef, measure] = useMeasure();

  useEffect(() => {
    setCssVar('--factory-title-height', `${measure.height}px`);
  }, [measure]);

  return (
    <ResourceTitle className="px-4 isolate" ref={titleRef}>
      {children}
    </ResourceTitle>
  );
};

export { FactoryTitle };
